<template>
  <Drawer
    width="800"
    :title="`${openedFactory ? '编辑' : '新增'}工厂`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem
          label="工厂名"
          prop="name"
        >
          <Input
            v-model="formItem.name"
            placeholder="输入材料名..."
          />
        </FormItem>
        <FormItem
          label="地址"
          prop="address"
        >
          <Input
            v-model="formItem.address"
            placeholder="输入地址..."
          />
        </FormItem>
        <FormItem
          label="本厂复配费（元/吨）"
          prop="compound_manufactCost"
        >
          <Input
            v-model="formItem.compound_manufactCost"
            placeholder="输入费用..."
          />
        </FormItem>
        <!-- <FormItem label="自产母液">
          <i-switch v-model="selfProduceSemi">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem> -->
        <h4>母液在本厂的制造费（元/吨）</h4>
        <FormItem>
          <Row>
            <Col span="6">
            <p>聚羧酸母液</p>
            <InputNumber
              :min="0"
              v-model="formItem.PCE_ML_manufactCost"
              placeholder="聚羧酸母液..."
            ></InputNumber>
            </Col>
            <Col span="6">
            <p>萘系母液</p>
            <InputNumber
              :min="0"
              v-model="formItem.NAP_ML_manufactCost"
              placeholder="萘系母液..."
            ></InputNumber>
            </Col>
            <Col span="6">
            <p>减胶剂母液</p>
            <InputNumber
              :min="0"
              v-model="formItem.J_ML_manufactCost"
              placeholder="减胶剂母液..."
            ></InputNumber>
            </Col>
            <Col span="6">
            <p>速凝剂母液</p>
            <InputNumber
              :min="0"
              v-model="formItem.FSA_ML_manufactCost"
              placeholder="速凝剂母液..."
            ></InputNumber>
            </Col>
          </Row>
        </FormItem>
        <FormItem
          label="禁用"
          prop="disabled"
        >
          <i-switch
            v-model="isInvalid"
            true-color="#ff4949"
            @on-change="changeInvalid"
          ></i-switch>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="handleSubmit('formItem')"
          >保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "EditFactoryDrawer",
  components: {},
  props: ["factoryList"],
  data() {
    return {
      drawerOpened: false,
      isInvalid: false,
      openedFactory: null,
      formItem: {
        name: null,
        address: null,
        PCE_ML_manufactCost: null,
        NAP_ML_manufactCost: null,
        J_ML_manufactCost: null,
        FSA_ML_manufactCost: null,
        compound_manufactCost: null,
      },
      ruleValidate: {
        name: [{ required: true, message: "名字为必填项", trigger: "submit" }],
      },
    };
  },
  computed: {
    ...mapGetters({
      semiMaterial: "material/semiMaterial",
    }),
  },
  methods: {
    ...mapActions({
      createFactory: "factory/createFactoryAction",
      updateFactory: "factory/updateFactoryAction",
      getMaterials: "material/getMaterialsAction",
    }),
    async openDrawer(factory) {
      this.$refs["formItem"].resetFields();
      this.formItem.name = null;
      this.formItem.address = null;
      this.formItem.PCE_ML_manufactCost = null;
      this.formItem.NAP_ML_manufactCost = null;
      this.formItem.J_ML_manufactCost = null;
      this.formItem.FSA_ML_manufactCost = null;
      this.formItem.compound_manufactCost = null;
      this.openedFactory = factory; // 如果有打开的材料，则为编辑模式
      await this.getMaterials();
      if (factory) {
        this.formItem.name = factory.name;
        this.formItem.address = factory.address;
        this.isInvalid = factory.disabled;
        this.formItem.compound_manufactCost = factory.compound_manufactCost;
        this.formItem.FSA_ML_manufactCost = factory.FSA_ML_manufactCost || null;
        this.formItem.J_ML_manufactCost = factory.J_ML_manufactCost || null;
        this.formItem.NAP_ML_manufactCost = factory.NAP_ML_manufactCost || null;
        this.formItem.PCE_ML_manufactCost = factory.PCE_ML_manufactCost || null;
      }
      this.drawerOpened = true;
    },
    changeInvalid(status) {
      this.formItem.disabled = status;
      this.isInvalid = status;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            const updateContent = this.formItem;
            if (this.openedFactory) {
              await this.updateFactory({
                id: this.openedFactory._id,
                data: updateContent,
              });
            } else {
              await this.createFactory(updateContent);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus"></style>
